import { render, staticRenderFns } from "./workflow-required-attributes.vue?vue&type=template&id=18b9b786&scoped=true&"
import script from "./workflow-required-attributes.vue?vue&type=script&lang=js&"
export * from "./workflow-required-attributes.vue?vue&type=script&lang=js&"
import style0 from "./workflow-required-attributes.vue?vue&type=style&index=0&id=18b9b786&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b9b786",
  null
  
)

export default component.exports